import { z } from 'zod'
import './registry'

/**
 * Upload presigning schemas. Consumed by handlers/uploads-presign.ts and the
 * frontend uploads service. Kept in their own domain module (not notes.ts)
 * so file organisation matches the access pattern.
 */
export const PresignRequestSchema = z
  .object({
    contentType: z
      .string()
      // Limited to the set the Anthropic SDK accepts as Vision input
      // (`identify` is downstream of this presign). HEIC was accepted here
      // historically but `identify` had no branch for it, so it was silently
      // relabelled as JPEG on the Vision call. The web frontend always
      // re-encodes to JPEG before upload anyway (see `image-resize.ts`).
      .regex(/^image\/(jpeg|png|webp)$/, 'supported: jpeg/png/webp'),
    // 'online-image' lands customer-facing record photos (front/back sleeve,
    // A/B record faces) in the shared media bucket under the `online/` prefix
    // (supplier logos share that bucket under `logos/`). The slot mapping
    // (which of the four) is tracked on the record's `onlineImages`, not here —
    // each slot is just an independent presign call returning an opaque key.
    purpose: z.enum(['record-photo', 'supplier-logo', 'online-image']),
  })
  .openapi('PresignRequest')

export const PresignResponseSchema = z
  .object({
    url: z.string().url(),
    key: z.string(),
    expiresIn: z.number().int(),
  })
  .openapi('PresignResponse')

export type PresignRequest = z.infer<typeof PresignRequestSchema>
export type PresignResponse = z.infer<typeof PresignResponseSchema>
